import { useState, useEffect, useMemo, useCallback } from "react";
import {
  getRecents,
  getFavorites,
  toggleFavorite as toggleFavoriteStorage,
  isFavoritePath,
} from "../navigation/navLauncherStorage";

/**
 * Recents / favorites with localStorage sync (same-tab + cross-tab).
 */
export function useNavLauncher() {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const bump = () => setTick((t) => t + 1);
    window.addEventListener("pm-nav-launcher-update", bump);
    window.addEventListener("storage", bump);
    return () => {
      window.removeEventListener("pm-nav-launcher-update", bump);
      window.removeEventListener("storage", bump);
    };
  }, []);

  const recents = useMemo(() => getRecents(), [tick]);
  const favorites = useMemo(() => getFavorites(), [tick]);

  const toggleFavorite = useCallback((path, label) => {
    return toggleFavoriteStorage(path, label);
  }, []);

  const isFavorite = useCallback(
    (path) => {
      return isFavoritePath(path);
    },
    [tick],
  );

  return {
    recents,
    favorites,
    toggleFavorite,
    isFavorite,
  };
}
